// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"634a5afd","520":"634a5afd","559":"d11ec7cb"}[chunkId] + ".chunk.css";
};